import { useAppSelector } from 'flow/hooks/useRedux';
import { selectCallRecordFromKey } from 'flow/selectors/call-records-selectors';
import { getCallRecordDisplayTimestamp } from 'flow/utils/call-record-utils';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { PageType } from 'flow/components/call-history-v2/types';

export const useCallRecordDisplayTimestamp = (
    callRecordKey: CallRecordKey | undefined,
    pageType?: PageType,
) => {
    const callRecord = useAppSelector((state) =>
        callRecordKey
            ? selectCallRecordFromKey(state, callRecordKey)
            : undefined,
    );
    return callRecord
        ? getCallRecordDisplayTimestamp(callRecord, pageType)
        : undefined;
};
